import React from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from "recharts";

function CustomXAxisTick({ x, y, payload }) {
  const lines = payload.value.split(" ");
  return (
    <text x={x} y={y} dy={16} textAnchor="middle" fill="#666">
      {lines.map((line, index) => (
        <tspan key={index} x={x} dy={16}>
          {line}
        </tspan>
      ))}
    </text>
  );
}

export default function ReservationTrimestreChart({
  data,
  year,
  setYear
}) {
  return (
    <div className="relative h-full">
      <select value={year} onChange={(e) => setYear(e.target.value)} className="outline-none absolute z-10 top-5 right-5 rounded-[10px] text-white bg-primary px-5 py-1 inline-block">
        <option className="bg-white text-black">{new Date().getFullYear() - 2}</option>
        <option className="bg-white text-black">{new Date().getFullYear() - 1}</option>
        <option className="bg-white text-black">{new Date().getFullYear()}</option>
      </select>
  
      <ResponsiveContainer width="100%" height="100%" className='absolute inset-0'>
        <LineChart
          data={data}
          margin={{ top: 30, right: 30, left: 0, bottom: 30 }}
        >
          <CartesianGrid strokeDasharray="3 3" vertical={false} />
          <XAxis dataKey="trimestre" tick={<CustomXAxisTick />} />
          <YAxis />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="réservation"
            stroke="#A31732"
            strokeWidth="2"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
